var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"persistenceKey":'customer-delivery-address-list'}})}
var staticRenderFns = []

export { render, staticRenderFns }